<template>
    <div>
        <rkm-area type="fieldset" title="X - Exsanguinação">
            <rkm-form-group label="Hemorragia externa grave">
                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-form-radio-group
                            v-model="data.model.hemorragiaExternaGraveTraumaStatusId"
                            centerInput
                        >
                            <rkm-form-radio :value="enums.trauma.AUSENTE">Ausente</rkm-form-radio>
                            <rkm-form-radio :value="enums.trauma.PRESENTE">Presente </rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :disabled="data.model.hemorragiaExternaGraveTraumaStatusId === null || data.model.hemorragiaExternaGraveTraumaStatusId === enums.trauma.AUSENTE"
                            placeholder="Local"
                            name="Local"
                            :validations="validations.hemorragiaExternaGraveLocal"
                            v-model="data.model.hemorragiaExternaGraveLocal"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form-group>
        </rkm-area>

        <rkm-area type="fieldset" title="A - Vias aéreas">
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-radio-group
                        v-model="data.model.viasAeriasTraumaStatusId"
                        centerInput
                    >
                        <rkm-form-radio :value="enums.trauma.PERVEAS">Pérveas</rkm-form-radio>
                        <rkm-form-radio :value="enums.trauma.OBSTRUCAO">Obstrução por</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :disabled="data.model.viasAeriasTraumaStatusId === null || data.model.viasAeriasTraumaStatusId === enums.trauma.PERVEAS"
                        :validations="validations.viasAeriasObstrucaoPor"
                        name="Obstrução por"
                        v-model="data.model.viasAeriasObstrucaoPor"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area type="fieldset" title="B - Oxigenação / Respiração / Ventilação">
            <rkm-row>
                <rkm-col>
                    <rkm-form-radio-group v-model="data.model.oxigenacaoRespiracaoVentilacaoTraumaStatusId">
                        <rkm-form-radio :value="enums.trauma.PRESENTE">Presente</rkm-form-radio>
                        <rkm-form-radio :value="enums.trauma.AUSENTE">Ausente</rkm-form-radio>
                        <rkm-form-radio :value="enums.trauma.SIMETRICA">Simétrica</rkm-form-radio>
                        <rkm-form-radio :value="enums.trauma.ASSIMETRICA">Assimétrica</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area type="fieldset" title="C - Circulação e hemorragias - Pulso">
            <rkm-row>
                <rkm-col cols="auto">
                    <rkm-form-radio-group
                        label="Pulso"
                        v-model="data.model.pulsoTraumaStatusId"
                    >
                        <rkm-form-radio :value="enums.trauma.PRESENTE">Presente</rkm-form-radio>
                        <rkm-form-radio :value="enums.trauma.AUSENTE">Ausente</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <rkm-form-group label="Pele">
                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-form-radio-group
                            v-model="data.model.peleTraumaStatusId"
                            centerInput
                        >
                            <rkm-form-radio :value="enums.trauma.NORMAL">Normal</rkm-form-radio>
                            <rkm-form-radio :value="enums.trauma.ALTERACOES">Alterações</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :disabled="data.model.peleTraumaStatusId === null || data.model.peleTraumaStatusId === enums.trauma.NORMAL"
                            :validations="validations.peleAlteracao"
                            name="Alterações"
                            v-model="data.model.peleAlteracao"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form-group>

            <rkm-form-group label="Perfusão">
                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-form-radio-group
                            v-model="data.model.perfuracaoTraumaStatusId"
                            centerInput
                        >
                            <rkm-form-radio :value="enums.trauma.NORMAL">Normal</rkm-form-radio>
                            <rkm-form-radio :value="enums.trauma.LENTIFICADA">Lentificada</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :disabled="data.model.perfuracaoTraumaStatusId === null || data.model.perfuracaoTraumaStatusId === enums.trauma.NORMAL"
                            append="segundos"
                            type="number"
                            name="Segundos"
                            :validations="validations.lentificada"
                            v-model="data.model.perfuracaoLentificada"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form-group>

            <rkm-form-group label="Sangramentos">
                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-form-radio-group
                            v-model="data.model.sangramentoTraumaStatusId"
                            centerInput
                        >
                            <rkm-form-radio :value="enums.trauma.AUSENTE">Ausente</rkm-form-radio>
                            <rkm-form-radio :value="enums.trauma.PRESENTE">Presente</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :disabled="data.model.sangramentoTraumaStatusId === null || data.model.sangramentoTraumaStatusId === enums.trauma.AUSENTE"
                            placeholder="Local"
                            name="Local"
                            :validations="validations.sangramentoLocal"
                            v-model="data.model.sangramentoLocal"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form-group>
        </rkm-area>

        <rkm-area type="fieldset" title="D - Avaliação neurológica - Pupilas">
            <rkm-row>
                <rkm-col>
                    <rkm-form-radio-group
                        label="Pupilas"
                        v-model="data.model.pupilasTraumaStatusId"
                    >
                        <rkm-form-radio :value="enums.trauma.ISOCORICAS">Isocóricas</rkm-form-radio>
                        <rkm-form-radio :value="enums.trauma.MIDRIASE">Midriase</rkm-form-radio>
                        <rkm-form-radio :value="enums.trauma.ANISOCORIA">Anisocoria</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-radio-group
                        label="Paresias"
                        v-model="data.model.paresiasTraumaStatusId"
                    >
                        <rkm-form-radio :value="enums.trauma.PRESENTE">Presente</rkm-form-radio>
                        <rkm-form-radio :value="enums.trauma.AUSENTE">Ausente</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-radio-group
                        label="Plegia"
                        v-model="data.model.plegiaTraumaStatusId"
                    >
                        <rkm-form-radio :value="enums.trauma.PRESENTE">Presente</rkm-form-radio>
                        <rkm-form-radio :value="enums.trauma.AUSENTE">Ausente</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area type="fieldset" title="E - Exposição e hipotermia">
            <rkm-form-group>
                <rkm-row>
                    <rkm-col cols="auto">
                        <rkm-form-radio-group
                            v-model="data.model.exposicaoHipotermiaTraumaStatusId"
                            centerInput
                        >
                            <rkm-form-radio :value="enums.trauma.SEM_LESOES">Sem lesões</rkm-form-radio>
                            <rkm-form-radio :value="enums.trauma.COM_LESOES">Com Lesões</rkm-form-radio>
                        </rkm-form-radio-group>
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            :disabled="data.model.exposicaoHipotermiaTraumaStatusId === null || data.model.exposicaoHipotermiaTraumaStatusId === enums.trauma.SEM_LESOES"
                            name="Com Lesões"
                            :validations="validations.exposicaoHipotermiaObservacao"
                            v-model="data.model.exposicaoHipotermiaObservacao"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-form-group>
        </rkm-area>
    </div>
</template>

<script>

import trauma from '@/enums/pronto-atendimento/observacao/paciente-trauma'

export default {
    data: () => ({
        enums: {
            trauma
        }
    }),
    props: {
        data: { type: Object, required: true },
    },
    computed: {
        validations() {

            return {
                lentificada: {
                    max: 3,
                    min: 1,
                    required: this.data.model.perfuracaoTraumaStatusId === this.enums.trauma.LENTIFICADA
                },
                hemorragiaExternaGraveLocal: {
                    required: this.data.model.hemorragiaExternaGraveTraumaStatusId === this.enums.trauma.PRESENTE
                },
                viasAeriasObstrucaoPor: {
                    required: this.data.model.viasAeriasTraumaStatusId === this.enums.trauma.OBSTRUCAO
                },
                peleAlteracao: {
                    required: this.data.model.peleTraumaStatusId === this.enums.trauma.ALTERACOES
                },
                sangramentoLocal: {
                    required: this.data.model.sangramentoTraumaStatusId === this.enums.trauma.PRESENTE
                },
                exposicaoHipotermiaObservacao: {
                    required: this.data.model.exposicaoHipotermiaTraumaStatusId === this.enums.trauma.COM_LESOES
                }
            }
        }
    },
    watch: {
        'data.model.hemorragiaExternaGraveTraumaStatusId' (value) {

            if(value === this.enums.trauma.AUSENTE) {
                this.data.model.hemorragiaExternaGraveLocal = null
            }
        },
        'data.model.viasAeriasTraumaStatusId' (value) {

            if(value === this.enums.trauma.PERVEAS) {
                this.data.model.viasAeriasObstrucaoPor = null
            }
        },
        'data.model.peleTraumaStatusId' (value) {

            if(value === this.enums.trauma.NORMAL) {
                this.data.model.peleAlteracao = null
            }
        },
        'data.model.perfuracaoTraumaStatusId' (value) {

            if(value === this.enums.trauma.NORMAL) {
                this.data.model.perfuracaoLentificada = null
            }
        },
        'data.model.sangramentoTraumaStatusId' (value) {

            if(value === this.enums.trauma.AUSENTE) {
                this.data.model.sangramentoLocal = null
            }
        },
        'data.model.exposicaoHipotermiaTraumaStatusId' (value) {

            if(value === this.enums.trauma.SEM_LESOES) {
                this.data.model.exposicaoHipotermiaObservacao = null
            }
        }
    }
}
</script>